import AuthErrorCodes from "domain/auth/AuthErrors";

// Define Backend Api possible error codes
enum AppErrorCodes {
    INVALID_IMAGE = "INVALID_IMAGE",
    ORGANIZATION_NOT_FOUND = "ORGANIZATION_NOT_FOUND",
    PROGRAM_NOT_FOUND = "PROGRAM_NOT_FOUND",
    WALLET_NOT_FOUND = "WALLET_NOT_FOUND",
    INVALID_WALLET = "INVALID_WALLET",
    PARTNER_NOT_FOUND = "PARTNER_NOT_FOUND",
    USER_ALREADY_IN_ORGANIZATION = "USER_ALREADY_IN_ORGANIZATION",
    FORBIDDEN = "FORBIDDEN",
    INVALID_ROLE_TYPE = "INVALID_ROLE_TYPE",
    INSUFFICIENT_TOKEN_AMOUNT = "INSUFFICIENT_TOKEN_AMOUNT",
    RECEIVER_NOT_FOUND = "RECEIVER_NOT_FOUND",
    ORGANIZATION_HAS_NO_TERMS = "ORGANIZATION_HAS_NO_TERMS",
    INVALID_IDENTIFICATION_CODE = "INVALID_IDENTIFICATION_CODE",
    ROLE_NOT_FOUND = "ROLE_NOT_FOUND",
    EMPTY_FILE = "EMPTY_FILE",
    USER_NOT_IN_ORGANIZATION = "USER_NOT_IN_ORGANIZATION",
    NOT_FOUND = "NOT_FOUND",
    TRANSACTION_NOT_FOUND = "TRANSACTION_NOT_FOUND",
}

export const ApiErrorCodes = { ...AppErrorCodes, ...AuthErrorCodes };

enum GenericErrorCodes {
    UNKNOWN_ERROR = "UNKNOWN_ERROR",
}

// Merge all module error codes here
const DomainErrorCodes = { ...GenericErrorCodes, ...ApiErrorCodes };

export type DomainErrorCode = keyof typeof DomainErrorCodes;

export default DomainErrorCodes;
